<div class="broker-container padding-hr padding-top">
  <div class="margin-24-vr font-28 font-inter-semibold flex-centered-container-vr text-primary-dark">
    <div>
      Broker Connectivity
    </div>
    <div class="margin-24-left width-20 padding font-18">
      Share India
    </div>
    <!-- TODO: might change when receiving DEFAULT BROKER from backend need changes -->
    <!-- <mat-select [value]="currentBroker"
      (selectionChange)="onBrokerChange($event)">
      <mat-option *ngFor="let broker of savedBrokers | keyvalue" [value]="broker.key">
        {{ broker.key }}
      </mat-option>
    </mat-select> -->
  </div>

  <div class="flex-space-between">
    <div class="half-width margin-24-right">
      <div *ngIf="currentBroker && !currentBroker.length">
        Please choose a Broker
      </div>

      <div *ngIf="currentBroker && currentBroker.length" class="display-flex-column">
        <div class=" margin-bot">
          <div class="flex-centered-container-vr font-20" *ngIf="currentBroker" [ngClass]="{
            'text-positive': connectionStatus && connectionStatus.is_connected,
            'text-negative': !(connectionStatus && connectionStatus.is_connected)
          }">
            <mat-icon class="materials-symbols-outlined">task_alt</mat-icon>
            <span class="margin-hr">
              {{ connectionStatus && connectionStatus.is_connected ? 'Connected to': "Disconnected from" }} <span>{{
                currentBroker }}</span>
            </span>
            <!-- *ngIf="BrokerLogo[currentBroker]" [src]="BrokerLogo[currentBroker]" -->
            <img src="/assets/share_india.jpg" class="img-32-sq" />
          </div>
        </div>

        <div *ngFor="let prop of savedBrokers[currentBroker] | keyvalue"
          class="display-flex dynamic-font padding-vr border-bot-light">
          <div class="width-40">
            {{ prop.key | sentence }}
          </div>
          <div class="font-inter-semibold" *ngIf="prop.key !== 'savedAt'">
            <ng-container>{{prop.key === "clientPassword" || prop.key === "clientPin" ? "*****" : prop.value}}</ng-container>
          </div>
          <div class="font-inter-semibold" *ngIf="prop.key === 'savedAt'">
            {{ prop.value * 1000 | date:DATE_TIME_FORMAT }}
          </div>
        </div>

        <div class="margin-24-top buttons">
          <button mat-raised-button disableRipple class="no-padding" color="accent"
            [disabled]="connectionStatus && connectionStatus.is_connected"
            (click)="openAddBrokerDialog(currentBroker)">
            Update
          </button>
          <button mat-raised-button disableRipple class="no-padding margin-hr" color="accent"
            (click)="deleteDetails(currentBroker)">
            Delete
          </button>
          <button mat-raised-button disableRipple class="no-padding" color="warn" (click)="logoutFromBroker()"
            *ngIf="connectionStatus && connectionStatus.is_connected">
            Logout
          </button>
          <button mat-raised-button disableRipple class="no-padding" color="accent" (click)="loginFromBroker()"
            *ngIf="!(connectionStatus && connectionStatus.is_connected)">
            Login
          </button>
        </div>

      </div>
    </div>

    <div class="half-width margin-left-24">
      <div class="display-flex-column">
        <div class="margin-bot flex-centered-vr-space-between-container">
          <div>More brokers to choose from</div>
          <div>
            <button mat-button color="accent" class="button-border-accent border-radius-8"
              [disabled]="connectionStatus && connectionStatus.is_connected"
              (click)="openAddBrokerDialog(currentBroker)">
              Add Broker
            </button>
          </div>
        </div>

        <div *ngFor="let broker of savedBrokers | keyvalue" class="flex-space-between margin-vr border-bot-light">
          <mat-checkbox>
            <mat-checkbox-label class="flex-centered-container-vr">
              <img src="/assets/share_india.jpg" class="img-32-sq margin-hr" /> <!-- broker.image is required -->
              <span>{{ broker.key }}</span>
            </mat-checkbox-label>
          </mat-checkbox>
          <span class="text-neutral">
            Free
          </span>
        </div>
      </div>
    </div>

  </div>
</div>
